//---------------------------------------------
// Devolutivas Module 
//---------------------------------------------
// Módulo para gerenciar as ações de upload e download de devolutiva

import axios from '../../services/api';
import Cookies from 'js-cookie';
// var FormData = require('form-data');
// var fs = require('fs');
// var data = new FormData();
// data.append('pdf', fs.createReadStream('/path/to/file'));

var JWT = () => {
    return (Cookies.get("accessToken") ? Cookies.get("accessToken") : "JWT VAZIO")
}

// STATES
const state = () => ({

    listFile: [],
    isListed: false,

    listYears: [],
    hasYears: false,
    
    listDash: [],
    isDashListed: false,

    //VERIFICACOES DOWNLOAD
    hasError: false,

    //VERIFICACOES UPLOAD
    isFileSent: null,
    tellError: ""
})

// MUTATIONS
const mutations = {
    //-- MUTATION PARA LISTAR O ARQUIVO
    setlistFile(state, payload) {
        state.listFile = payload
    },
    setIsListed(state, payload) {
        state.isListed = payload
    },

    //-- MUTATION PARA LISTAR OS ANOS
    setlistYears(state, payload) {
        state.listYears = payload
    },
    setHasYears(state, payload) {
        state.hasYears = payload
    },
    
    //-- MUTATION PARA LISTAR LINKS DASHBOARD
    setListDash(state, payload) {
        state.listDash = payload
    },
    setIsDashListed(state, payload) {
        state.isDashListed = payload
    },

    //-- VERIFICAÇÕES DOWNLOAD
    setHasError(state, payload) {
        state.hasError = payload
    },

    //-- VERIFICAÇÕES UPLOAD
    setIsFileSent(state, payload) {
        state.isFileSent = payload
    },
    setErrorMessage(state, payload) {
        state.tellError = payload
    },
}

// ACTIONS
const actions = {
    //-- ACTION LISTAR DEVOLUTIVAS
    //ainda precisa utilizar os parametros para a verificação do download
    async setListDevolutivas({commit},payload)  {
        await axios
            .get(`file`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                },
                params: {
                    bucketName: 'sapidesv',
                    idRegional: payload.idRegional,
                    idMunicipio: payload.idMunicipio
                },
            })
            .then((response) => {
                commit('setIsListed', true);
                commit('setlistFile', response.data);
            })
            .catch((error) => {
                commit('setIsListed', false);
                console.log(error.message)
            })
    },

    
    //-- ACTION LISTAR LINK DASHBOARDS
    async setListDashboards({commit},payload)  {
        await axios
            .get(`panorama-graphics`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                },
                params: {
                    idRegional: payload.idRegional,
                    idMunicipio: payload.idMunicipio,
                    tipoDevolutiva: payload.tipoDevolutiva,
                },
            })
            .then((response) => {
                commit('setIsDashListed', true);
                commit('setListDash', response.data);
            })
            .catch((error) => {
                commit('setIsDashListed', false);
                console.log(error.message)
            })
    },


    //-- ACTION LISTAR ANOS
    async setListExistentYears({commit},payload)  {
        await axios
            .get(`file/years-available`, {
                headers: {
                    'Authorization': `Bearer ${JWT()}`
                },
                params: {
                    bucketName: 'sapidesv',
                    tipoDevolutiva: payload.tipoDevolutiva,
                },
            })
            .then((response) => {
                commit('setHasYears', true);
                commit('setlistYears', response.data);
            })
            .catch((error) => {
                commit('setHasYears', false);
                console.log(error.message)
            })
    },


    //-- ACTION POST DEVOLUTIVA 
    async setUploadDevolutiva({commit}, payload) {
        await axios
            .post(`file/upload/pdf?idMunicipio=${payload.idMunicipio}&idRegional=${payload.idRegional}&anoDevolutiva=${payload.anoDevolutiva}&tipoDevolutiva=${payload.tipoDevolutiva}`, 
            payload.formData,
            {
                headers: {
                    'Authorization': `Bearer ${JWT()}`,
                    'Content-Type':'multipart/form-data'
                },
            })
            .then(() => {
                commit('setIsFileSent', true)
            })
            .catch((error) => {
                console.log(error.message);
                commit('setIsFileSent', false)
                commit('setErrorMessage', error.message)
            })
    },


    //testar depois
    //-- ACTION POST DOWNLOAD DEVOLUTIVA
    async setDownloadDevolutiva({commit},payload) {
        await axios
            .post(`/file/download/pdf`, {} ,
            {
                headers: {
                    'Authorization': `Bearer ${JWT()}`,
                },
                responseType: 'blob',
                params: {
                    bucketName: 'sapidesv',
                    fileId: payload.fileId,
                    idRegional:payload.idRegional,
                    idMunicipio:payload.idMunicipio
                },
            })
            .then((res) => {
                var file = new Blob([res.data], {type: 'application/pdf'});
                var fileURL = URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = fileURL;
                link.setAttribute('download', payload.filename);
                document.body.appendChild(link);
                link.click();
                commit('setHasError', false);
            })
            .catch((error) => {
                commit('setHasError', true);
                console.log(error.message);
            })
    },
}

// GETTERS
const getters = {
    getListDevolutivas(state) {
        try {
            return state.listFile.data
        } catch (e) {
            return e
        }
    },
    getIsListed(state){
        return state.isListed
    },

    getListDashboards(state) {
        try {
            return state.listDash.data
        } catch (e) {
            return e
        }
    },
    getIsDashListed(state){
        return state.isDashListed
    },

    getHasError(state){
        return state.hasError
    },

    getIsFileSent(state) {
        return state.isFileSent
    },

    getListYears(state) {
        try {
            return state.listYears.data
        } catch (e) {
            return e
        }
    },

    getHasYears(state) {
        return state.hasYears
    },

    getErrorMessage(state) {
        return state.tellError
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
